/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_IntroInputs */

const en_terms_intro = /** @type {(inputs: Terms_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These terms govern your use of Bystep (bystep.dev), the Bystep CLI and MCP server, operated from Indonesia. By creating an account or using the service you agree to them.`)
};

const id_terms_intro = /** @type {(inputs: Terms_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketentuan ini mengatur penggunaan Bystep (bystep.dev), Bystep CLI, dan server MCP, yang dioperasikan dari Indonesia. Dengan membuat akun atau memakai layanan, kamu menyetujuinya.`)
};

/**
* | output |
* | --- |
* | "These terms govern your use of Bystep (bystep.dev), the Bystep CLI and MCP server, operated from Indonesia. By creating an account or using the service you a..." |
*
* @param {Terms_IntroInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_intro = /** @type {((inputs?: Terms_IntroInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_IntroInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_intro(inputs)
	return en_terms_intro(inputs)
});